(function ($) {
	const app = {
		windowHeight: $(window).height(),
		windowWidth: $(window).width(),
		isMobile: false,
		isTouch: false,
		resizeTimeoutID: null,
		$body: $('body'),
		culture: 'en',
		isIe: false,
		responsiveBreakpointValue: '(max-width: 1200px)',
		responsiveBreakpointBoolean: false,
		hamburgerBoolean: false,
		hamburgerBoolean2: false,
		successSwiper: false,
		tabSwiper: null,
		disableAnimation: false,
		lifestyleSwiper: null,
		markersArray: [],
		//	gallerySlider: '',
		detectDevice() {

			(function (a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
					app.isMobile = true;
				}
			}(navigator.userAgent || navigator.vendor || window.opera));
			if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
				app.isTouch = true;
				app.$body.addClass('touch');
			} else {
				app.$body.addClass('no-touch');
			}
		},
		detectCulture() {
			if ($('body').hasClass('ar')) {
				app.culture = 'ar';
			}
		},
		windowResize() {
			app.windowHeight = $(window).height();
			app.windowWidth = $(window).width();
			$('.spotlight__slide.swiper-slide').height($('.swiper-spacer').outerHeight())
		},
		resizeListner() {
			if (!app.isMobile) {
				$(window).resize(() => {
					clearTimeout(app.resizeTimeoutID);
					app.resizeTimeoutID = setTimeout(app.windowResize, 500);
				});
			} else {
				window.addEventListener('orientationchange', () => {
					app.windowResize();
				});
			}
		},
		addEventListner() {
			$('.header__menu').click(function () {
				$('.menu--header').addClass('active')
				$('body').addClass('menu-open')
			})
			$('.menu__close').click(function () {
				$('.menu--header').removeClass('active')
				$('body').removeClass('menu-open')
			})
			$('.floating-tools__btn').click(function () {
				$(this).toggleClass('active')
				$('.floating-tools .tools').toggleClass('active')
			})

			// $('.form-btn').click(function (e) {
			// 	e.preventDefault()
			// 	$('.inquire__calculator').removeClass('d-none')
			// 	$('.inquire__form').addClass('d-none')
			// })
			$('.right-product__item').click(function () {
				$('.right-product__item').removeClass('active');
				$(this).addClass('active');

				$('.right-product__arrow').css('left', ($(this).offset().left + ($(this).width() / 2) - 12) - $('.right-product__items').offset().left)

				$('.right-product__options').slideUp()
				$('.right-product').addClass('active')
				$('.right-product__options').eq($(this).parent().index()).slideDown()

			})

		},
		lazyLoad: function () {

			var lazyLoadInstance = new LazyLoad({
				// Your custom settings go here
			});
		},
		swiper: function () {

			const spotlightSwiper = new Swiper('.spotlight .swiper', {

				pagination: {
					el: '.spotlight__pagination',
					clickable: true,
					renderBullet: function (index, className) {
						return `<span class="${className}">${$('.spotlight .swiper-slide').eq(index).data('slide-caption')}</span>`;
					},
				},
				slidesPerView: 1,
				spaceBetween: 0,

				on: {
					slideChange: function (swiper) {
						//console.log(swiper.activeIndex)
						if ($('.spotlight .swiper-slide').eq(swiper.activeIndex).find('video').length === 1)
							$('.spotlight .swiper-slide').eq(swiper.activeIndex).find('video').get(0).play()
					}
				}
			});
			new Swiper('.right-product__items .swiper', {


				slidesPerView: 2.2,
				spaceBetween: 15,

				breakpoints: {
					1200: {
						slidesPerView: 3.5,
						// spaceBetween: 20
					},
					1400: {
						slidesPerView: 5,
						// spaceBetween: 20
					}
				}



			});

			const tabBannerSwiper = new Swiper('.tab-sliding-banner .swiper', {

				pagination: {
					el: '.tab-sliding-banner__pagination',
					clickable: true,

					renderBullet: function (index, className) {
						return `<span class="${className}">${$('.tab-sliding-banner .swiper-slide').eq(index).data('slide-caption')}</span>`;
					},
				},
				slidesPerView: 1,
				spaceBetween: 0,
				allowTouchMove: false,
				autoHeight: true,

				on: {
					slideChange: function (swiper) {
						//console.log(swiper.activeIndex)
						if ($('.tab-sliding-banner .swiper-slide').eq(swiper.activeIndex).find('video').length === 1)
							$('.tab-sliding-banner .swiper-slide').eq(swiper.activeIndex).find('video').get(0).play()
					}
				}
			});

			const newsSwiper = new Swiper('.news__slider .swiper', {

				pagination: {
					el: '.news__slider__pagination',
					clickable: true
				},
				preloadImages: false,
				lazy: true,
				slidesPerView: 1.1,
				spaceBetween: 20,
				breakpoints: {
					1400: {
						slidesPerView: 4,
						
					},
					1200: {
						slidesPerView: 3.2,
						
					},
					992: {
						slidesPerView: 2.2,
						 
					},
				}

			});

			const featureSliderMob = new Swiper('.feature-slider-lg-mob .swiper', {
				pagination: {
					el: '.feature-slider-lg-mob__pagination',
					clickable: true
				},
				preloadImages: false,
				lazy: true,
				slidesPerView: 1,
				spaceBetween: 20,
			});

			app.tabSwiper = new Swiper('.dynamic-banking__slider .swiper', {

				pagination: {
					el: '.tab-swiper-pagination',
					clickable: true,
				},
				slidesPerView: 1,
				spaceBetween: 0,
				preloadImages: false,
				lazy: true,
				on: {
					slideChange: function (swiper) {
						// //console.log(swiper.activeIndex)
						$('.tabs-nav__list').eq(swiper.activeIndex).find('.tabs-nav__link').click();
					}
				}
			});

			app.lifestyleSwiper = new Swiper('.lifestyle__swiper-slider .swiper', {

				pagination: {
					el: '.lifestyle__swiper-slider__pagination',
					clickable: true,
					renderBullet: function (index, className) {
						return `<span class="${className}">${$('.lifestyle__swiper-slider .swiper-slide').eq(index).data('slide-caption')}</span>`;
					},
				},
				slidesPerView: 1,
				spaceBetween: 0,
				allowTouchMove: false,

				on: {
					slideChange: function (swiper) {
						//console.log(swiper.activeIndex)
						app.disableAnimation = false
						$('.lifestyle__card').eq(swiper.activeIndex).trigger('click')
						$('.lifestyle__details').hide();
						$('.lifestyle__details').eq(swiper.activeIndex).show();

					}
				}
			});

			const threeCardSwiper = new Swiper(".three-card-swiper", {
				slidesPerView: "auto",
				spaceBetween: 20,
				breakpoints: {
					320: {
						slidesPerView: 1.2,
					},
					1000: {
						slidesPerView: 3,
					},

				}
			});
			const twoCardSwiper = new Swiper(".two-card-swiper", {
				slidesPerView: "auto",
				spaceBetween: 20,
				breakpoints: {
					320: {
						slidesPerView: 1.2,
					},
					1000: {
						slidesPerView: 3,
					},

				}
			});


		},
		productFinder: function () {

			$('.spotlight .product-finder').hover(function () {
				gsap.to(".spotlight .tools__path", { duration: 0.5, x: -5.026, y: -5.038, morphSVG: ".spotlight .tools__path1" });
				gsap.to(".spotlight .product-finder path", { duration: 0.5, fill: '#fff', stroke: '#fff' });
				//console.log("in")
			}, function () {
				//console.log("out")
				gsap.to(".spotlight .tools__path", { duration: 0.5, x: 0.25, y: 0.25, morphSVG: ".spotlight .tools__path" });
				gsap.to(".spotlight .product-finder path", { duration: 0.5, fill: 'none', stroke: '#263743' });
			})
			$('.floating-tools .product-finder').hover(function () {
				gsap.to(".floating-tools .tools__path", { duration: 0.5, x: -5.026, y: -5.038, morphSVG: ".floating-tools .tools__path1" });
				gsap.to(".floating-tools .product-finder path", { duration: 0.5, fill: '#fff', stroke: '#fff' });
				//console.log("in")
			}, function () {
				//console.log("out")
				gsap.to(".floating-tools .tools__path", { duration: 0.5, x: 0.25, y: 0.25, morphSVG: ".floating-tools .tools__path" });
				gsap.to(".floating-tools .product-finder path", { duration: 0.5, fill: 'none', stroke: '#263743' });
			})




			const items = document.querySelectorAll('.spotlight .tools')


			if (items.length === 0) {
				$('.floating-tools__btn').addClass('visible')
			}


			let observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {



					if (entry.isIntersecting) {
						$('.floating-tools__btn').removeClass('visible active')
						$('.floating-tools .tools').removeClass('active')
					}
					else {
						$('.floating-tools__btn').addClass('visible')
					}
				});
			}, { rootMargin: "0px 0px 0px 0px" });

			items.forEach(item => {
				observer.observe(item);
			});


		},
		bankServices: function () {
			var plusIcon = $(".banking-services .plus-cut-icon")
			plusIcon.on("click", function () {
				$(this).parents('.banking-services').toggleClass("banking-services--expand");
			});

			var plusIcon2 = $(".banking-program-card .plus-cut-icon")
			plusIcon2.on("click", function () {
				$(this).parents('.banking-program-card').toggleClass("banking-program-card--show");
			});

		},
		tabs() {

			const tabNav = $('.tabs__head');
			const activeClass = 'active';
			let $this;
			let currentIndex;

			$.each(tabNav, function (index, elem) {
				const selector = $(elem);
				const tabNavList = selector.find('> ul > li');
				const tabPane = selector.parent().find('.tabs__pane');
				tabNavList.eq(0).find('> a').addClass(activeClass);
				tabPane.eq(0).addClass(activeClass);

				tabNavList.on('click', function (e) {
					$this = $(this);

					if (app.isMobile) {
						$this.find('a').get(0).scrollIntoView(true)
					}
					else {
						$this.find('a').get(0).scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
					}


					// if (!$this.parent().hasClass('js-hash-clickable')) {
					// 	// debugger
					// 	e.preventDefault()
					// }
					currentIndex = $this.index();
					if ($this.parent().hasClass('js-has-slide-to'))
						app.tabSwiper.slideTo(currentIndex);


					tabPane.removeClass(activeClass);
					$this.closest('.tabs__head').next().find('.tabs__pane').eq(currentIndex).addClass(activeClass);
					tabNavList.find('> a').removeClass(activeClass);

					if (!$this.find('> a').hasClass(activeClass)) {
						$this.find('> a').addClass(activeClass);
					}

				});

			});
			let url = window.location;
			let qs = url.hash;
			let qsText = qs.slice(1, qs.length);


			if (qsText) {

				$('[href="#' + qsText + '"]').click();



				// if ($('.js-hash-clickable').length) {
				// 	$('[href="#' + qsText + '"]').click();
				// 	$('html, body').animate({
				// 		scrollTop: $('[href="#' + qsText + '"]').offset().top - 100
				// 	}, 300);
				// } else {
				// 	$('.tabs-nav__list').each(function (i, elem) {
				// 		if ($(elem).find('.tabs-nav__link').text().toLowerCase() === qsText) {
				// 			$(elem).find('.tabs-nav__link').click();
				// 			$('html, body').animate({
				// 				scrollTop: $('.tabs__body').offset().top
				// 			}, 300);
				// 		}
				// 	});
				// }
			}

		},

		rangeSlider() {
			let homeLoanAmount = $('#home-loan-amount').attr('data-min');
			let homeLoanTenure = $('#home-loan-tenure').attr('data-min');
			let personalLoanAmount = $('#personal-loan-amount').attr('data-min');
			let personalLoanTenure = $('#personal-loan-tenure').attr('data-min');
			let autoLoanAmount = $('#auto-loan-amount').attr('data-min');
			let autoLoanTenure = $('#auto-loan-tenure').attr('data-min');



			var $range = $(".js-range-slider"),
				min = 1,
				max = 10;

			$range.ionRangeSlider({
				skin: "modern",
				type: "single",
				min: min,
				max: max,
				from: 10,
				prettify: function (num) {
					var tmp_min = min,
						tmp_max = max,
						tmp_num = num;

					if (min < 0) {
						tmp_min = 0;
						tmp_max = max - min;
						tmp_num = num - min;
						tmp_num = tmp_max - tmp_num;
						return tmp_num + min;
					} else {
						num = max - num;
						return num;
					}
				}
			});


			$(".range-slider").each(function () {

				var $this = $(this),
					rangeInput = $(this);

				var min =
					$this.data("min") === "" || $this.data("min") === undefined
						? 5
						: $this.data("min");
				var max =
					$this.data("max") === "" || $this.data("max") === undefined
						? 30
						: $this.data("max");

				// debugger

				//console.log(min + ' : min');
				//console.log(max + ' : max');

				var reverse = function (num) {
					return max - (num - min);
				};




				rangeInput.ionRangeSlider({


					prettify_enabled: true,
					prettify_separator: ",",

					from: app.culture === 'ar' ? max : min,

					prettify: function (num) {

						if (app.culture === 'ar') {
							return num = reverse(num);
							/* var tmp_min = min,
								tmp_max = max,
								tmp_num = num;

							if (min < 0) {
								tmp_min = 0;
								tmp_max = max - min;
								tmp_num = num - min;
								tmp_num = tmp_max - tmp_num;
								return tmp_num + min;
							} else {
								num = max - num;
								return num + 1;
							} */

						} else {

							return num;

						}


					},

					/* prettify: function (num) {
						//console.log(num);

						if (app.isRTL) {
							num = reverse(num);
						}

						var tmp_min = min,
							tmp_max = max,
							tmp_num = num;

						if (min < 0) {
							tmp_min = 0;
							tmp_max = max - min;
							tmp_num = num - min;
							tmp_num = tmp_max - tmp_num;
							return tmp_num + min;
						} else {
							num = max - num;
							return num;
						}




					}, */

					/* 	onStart: function (data) {
							fixPosition(data.slider, 0);
						}, */

					onChange: function (data) {



						if ($(data.input).attr('id') === 'home-loan-amount') {


							homeLoanAmount = data.from_pretty
						}
						if ($(data.input).attr('id') === 'home-loan-tenure') {
							homeLoanTenure = data.from_pretty
						}
						if ($(data.input).attr('id') === 'personal-loan-amount') {
							personalLoanAmount = data.from_pretty
						}
						if ($(data.input).attr('id') === 'personal-loan-tenure') {
							personalLoanTenure = data.from_pretty
						}
						if ($(data.input).attr('id') === 'auto-loan-amount') {
							autoLoanAmount = data.from_pretty
						}
						if ($(data.input).attr('id') === 'auto-loan-tenure') {
							autoLoanTenure = data.from_pretty
						}


						app._calculateLoan(homeLoanAmount, homeLoanTenure, parseFloat($('#home-loan-values').attr('data-interest')), $('#home-loan-values'))
						app._calculateLoan(personalLoanAmount, personalLoanTenure, parseFloat($('#personal-loan-values').attr('data-interest')), $('#personal-loan-values'))
						app._calculateLoan(autoLoanAmount, autoLoanTenure, parseFloat($('#auto-loan-values').attr('data-interest')), $('#auto-loan-values'))






					},

				});

			});


			$(".range-slider-100").ionRangeSlider({
				prettify_enabled: true,
				prettify_separator: ",",
				onChange: function (data) {



					if ($(data.input).attr('id') === 'home-loan-amount') {
						homeLoanAmount = data.from
					}
					if ($(data.input).attr('id') === 'home-loan-tenure') {
						homeLoanTenure = data.from
					}
					if ($(data.input).attr('id') === 'personal-loan-amount') {
						personalLoanAmount = data.from
					}
					if ($(data.input).attr('id') === 'personal-loan-tenure') {
						personalLoanTenure = data.from
					}
					if ($(data.input).attr('id') === 'auto-loan-amount') {
						autoLoanAmount = data.from
					}
					if ($(data.input).attr('id') === 'auto-loan-tenure') {
						autoLoanTenure = data.from
					}


					app._calculateLoan(homeLoanAmount, homeLoanTenure, parseFloat($('#home-loan-values').attr('data-interest')), $('#home-loan-values'))
					app._calculateLoan(personalLoanAmount, personalLoanTenure, parseFloat($('#personal-loan-values').attr('data-interest')), $('#personal-loan-values'))
					app._calculateLoan(autoLoanAmount, autoLoanTenure, parseFloat($('#auto-loan-values').attr('data-interest')), $('#auto-loan-values'))






				},
			});

		},

		customSelect: function () {

			$(".custom-select").selectize({
				create: true,
				//sortField: "text",


			});


			$('#field1').change(function () {
				//console.log($(this).val())

				$('.form-btn').removeClass('disabled').attr('href', $(this).val())


			})
		},


		lifestyleAnimation: function () {

			var grid = $('.lifestyle__card');
			$('.lifestyle__details').eq(0).show();


			if (grid.length !== 0) {
				// app.disableAnimation ;

				var placeholder = $('.lifestyle__placeholder');
				var container = $('.lifestyle__slider').offset().left;

				grid.eq(0).css({
					left: placeholder.eq(1).offset().left - container,
					width: placeholder.eq(1).width()

				})
				grid.eq(1).css({
					left: placeholder.eq(0).offset().left - container,
					width: placeholder.eq(0).width()

				})
				grid.eq(2).css({
					left: placeholder.eq(2).offset().left - container,
					width: placeholder.eq(2).width()

				})



				grid.click(function () {


					//console.log(app.disableAnimation)


					if (!app.disableAnimation) {

						//	//console.log()
						app.lifestyleSwiper.slideTo($(this).attr('data-original-index'))
						$('.lifestyle .swiper-pagination .swiper-pagination-bullet').removeClass(' swiper-pagination-bullet-active')
						$('.lifestyle .swiper-pagination .swiper-pagination-bullet').eq($(this).attr('data-original-index')).addClass('swiper-pagination-bullet-active')


						app.disableAnimation = true

						////console.log($(this).data().index)

						if ($(this).attr('data-index') === "0") {


							$(this).css({
								left: placeholder.eq(1).offset().left - container,
								width: placeholder.eq(1).width()
							}).removeClass('lifestyle__card--first').addClass('lifestyle__card--active')
							$('.lifestyle__card[data-index=1]').css({
								left: placeholder.eq(0).offset().left - container,
								width: placeholder.eq(0).width(),

							}).addClass('lifestyle__card--first').removeClass('lifestyle__card--active')

							setTimeout(() => {
								$('.lifestyle__card[data-index=1]').attr('data-index', "0")
								$(this).attr('data-index', "1")
								app.disableAnimation = false
							}, 300)




						}
						else if ($(this).attr('data-index') === "2") {

							$(this).css({
								left: placeholder.eq(1).offset().left - container,
								width: placeholder.eq(1).width(),

							}).removeClass('lifestyle__card--last').addClass('lifestyle__card--active')
							$('.lifestyle__card[data-index=1]').css({
								left: placeholder.eq(2).offset().left - container,
								width: placeholder.eq(2).width()
							}).addClass('lifestyle__card--last').removeClass('lifestyle__card--active')

							setTimeout(() => {
								$('.lifestyle__card[data-index=1]').attr('data-index', "2")
								$(this).attr('data-index', "1")
								app.disableAnimation = false
							}, 500)





						}
					}

				})

			}
		},


		googleMap: function () {










			const url = `${$('#atm-location').attr('data-url')}?pageId=${$("#branchesListParentId").val()}`;




			var markup = ``





			$.ajax({
				url,
				contentType: "application/json",
				dataType: "json", 

			}).done(function (data) {

				//	if(data !== 'undefined') return false
				console.log(data) 
				console.log(data.Result)

				loadBranches(data.Result.Locations, true)
				loadTypes(data.Result.Types)
				$('.atm-location__list').click(function () {
					$('.atm-location__list').removeClass('active')

					$(this).addClass('active')

					$('.atm-location__map-iframe iframe').attr('src', $(this).attr('data-url'))
				})

				$('.atm-location .tabs-nav__link ').click(function () {

					$('.atm-location__list').removeClass('d-none')

					$('.atm-location .tabs-nav__link').removeClass('active')
					$(this).addClass('active')

					var type = 	$(this).attr('data-type')
				 

					$('.atm-location__list').each(function () {

						if(type == 0){
							$('.atm-location__list').removeClass('active');
							return false
						}
					 
						if($(this).attr('data-type') !== type){
							$(this).addClass('d-none')
						}
					})

				})




			});

			function loadTypes(data = []) {

				var types = '';

				for (let index = 0; index < data.length; index++) {
					console.log(data[index])



					types += `  <li  class="tabs-nav__list"><a class="tabs-nav__link ${index === 0 ? 'active' : ''}" data-type='${data[index].Type}' href="javascript:void(0)">${data[index].CategoryName}</a></li>`






				}


				$('.atm-location .tabs-nav').append(types)




			}



			function loadBranches(data = [], loadMarkers = false) {

				for (let index = 0; index < data.length; index++) {


					if (index === 0) {
						$('.atm-location__map-iframe iframe').attr('src', data[index].EmebededGoogleMapsLink)
					}

					markup += `<div class="atm-location__list ${index === 0 ? 'active' : ''}" data-type='${data[index].LocationType}' data-title='${data[index].LocationName}' data-url='${data[index].EmebededGoogleMapsLink}'>
					<div class="atm-location__list-left">
					  <h4 class="h4">${data[index].LocationName}
					  </h4>
					  <div class='${data[index].NormalTimings ? ' atm-location__copy' : 'd-none atm-location__copy'}'>

					
					  
					  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
					  <g  data-name="Group 13954" transform="translate(-1393.969 -5402.5)">
						<path data-name="Path 6308" d="M119.5,62.6a7.5,7.5,0,1,0-7.5-7.5A7.516,7.516,0,0,0,119.5,62.6Zm0-14.294a6.794,6.794,0,1,1-6.794,6.794A6.808,6.808,0,0,1,119.5,48.306Z" transform="translate(1282.469 5355.4)" fill="#0095c8" stroke="#0095c8" stroke-width="1"/>
						<path  data-name="Path 6309" d="M340.6,125.691l.555-.308-1.742-3.161V117.6H338.8v4.7l.031.154Z" transform="translate(1062.765 5288.617)" fill="#0095c8" stroke="#0095c8" stroke-width="1"/>
					  </g>
					</svg>
					
					<p>
					 <span>
					   ${data[index].WorkingDays}  ${data[index].NormalTimings} 
					   </span>

					   <span>
					   ${data[index].SaturdayTimings} 
					  </span>
					  <span>
					   ${data[index].BreakTimings} 
					   </span>
					   <span>
					   ${data[index].FridayTimings} 
					   </span>
					   </p>
					  </div>


					  <div class='${data[index].Phone ? ' atm-location__copy' : 'd-none atm-location__copy'}'>
					  
					  <svg xmlns="http://www.w3.org/2000/svg" width="16.924" height="16.139" viewBox="0 0 16.924 16.139">
					  <g   data-name="Group 13953" transform="translate(-1477.779 -5558.258)">
						<path   data-name="Path 6235" d="M13.58,9.213c-.976-.5-1.951-.96-2.689-1.307a.839.839,0,0,0-1.114.334c-.034.049-.069.1-.1.147-.18.254-.365.516-.56.762-.319.4-.45.437-.934.239A8.8,8.8,0,0,1,3.939,5.662a.414.414,0,0,1,.038-.572c.054-.059.11-.12.162-.179a4.95,4.95,0,0,0,.606-.745,1.087,1.087,0,0,0,.139-.857C4.54,2.383,4.147,1.472,3.739.544a.819.819,0,0,0-.488-.46A2.146,2.146,0,0,0,1.178.53,3.881,3.881,0,0,0,.3,1.816,4.137,4.137,0,0,0,0,3.343v.01l0,.01c.007.062.011.126.015.187.011.139.021.282.044.424A7.71,7.71,0,0,0,1.53,7.136,17.336,17.336,0,0,0,3.1,9.087a13.883,13.883,0,0,0,1.815,1.625A12.561,12.561,0,0,0,7,11.973a12.912,12.912,0,0,0,2.378.858,4.653,4.653,0,0,0,1.143.151,3.94,3.94,0,0,0,2.08-.6A2.742,2.742,0,0,0,13.92,9.793a.736.736,0,0,0-.341-.58Zm-.025.585a2.375,2.375,0,0,1-1.142,2.273,3.666,3.666,0,0,1-2.943.4A13.028,13.028,0,0,1,1.832,6.925,7.37,7.37,0,0,1,.423,3.914C.4,3.788.393,3.657.382,3.52c0-.061-.01-.121-.015-.183A3.493,3.493,0,0,1,1.437.789,1.752,1.752,0,0,1,3.18.44a.5.5,0,0,1,.226.247c.4.924.8,1.83,1.137,2.747a.749.749,0,0,1-.106.536,4.632,4.632,0,0,1-.563.69c-.054.059-.111.12-.165.182A.775.775,0,0,0,3.628,5.85a10.267,10.267,0,0,0,1.885,2.3A8.713,8.713,0,0,0,8.041,9.724a1.234,1.234,0,0,0,.755.121,1.161,1.161,0,0,0,.6-.473c.2-.252.388-.519.572-.776.034-.049.069-.1.1-.146a.477.477,0,0,1,.66-.215c.737.344,1.707.8,2.678,1.3a.424.424,0,0,1,.143.262Z" transform="translate(1480.383 5558.825) rotate(9)" fill="#0095c8" stroke="#0095c8" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
					  </g>
					</svg>
					
					
					 <p>
					 
					<a href=' tel:${data[index].Phone} '> ${data[index].Phone} </a>
					 
					 </p>
					  </div>
					 
					</div>
					 
				  </div>`






				}

				$('#atm-location-list').append(markup)

			}















			$('#search-location').keyup(function () {
				var val = $(this).val().toLowerCase();
				$('.atm-location__list').hide()
				$('.atm-location__list').each(function () {
					// $('.atm-location__list').hide()
					if ($(this).attr('data-title').toLowerCase().includes(val)) {
						$(this).show()
					}
					if ($('.atm-location__list:visible').length === 0) {
						$('.atm-location__error').show()
					}
					else {
						$('.atm-location__error').hide()
					}
				})


			})







		},



		imageVideo() {
			// Gets the video src from the data-src on each button            
			var $videoSrc;
			$('.image-video__v-image .btn-play').click(function () {
				$videoSrc = $(this).data("src");
				$('.image-video__overlay').fadeIn();
				$(".image-video__overlay-iframe #video").attr('src', $videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");
			});
			$('.image-video__overlay .close').click(function () {
				$('.image-video__overlay').fadeOut();
				$(".image-video__overlay-iframe #video").attr('src', "");
			});
		},
		_calculateLoan: function (total, years, ratePercent, elem) {
			console.log(total, years)

			const monthlyRate = total * (((ratePercent / 12) / 100) * Math.pow(1 + ((ratePercent / 12) / 100), years * 12) / (Math.pow(1 + ((ratePercent / 12) / 100), years * 12) - 1));
			const months = years * 12;
			const totalAmount = monthlyRate * months;
			const totalInterest = totalAmount - total;




			elem.find('.loan-tenure').text(months)
			elem.find('.loan-interest').text(totalInterest.toLocaleString(undefined, {
				minimumFractionDigits: 1,
				maximumFractionDigits: 1
			}))
			elem.find('.loan-total').text(totalAmount.toLocaleString(undefined, {
				minimumFractionDigits: 1,
				maximumFractionDigits: 1
			}))
			elem.find('.loan-monthly').text(monthlyRate.toLocaleString(undefined, {
				minimumFractionDigits: 1,
				maximumFractionDigits: 1
			}))














		},

		accordion: function () {
			var elem = $(".accordion"),
				elemTarget = elem.find(".accordion__heading"),
				activeClass = "accordion--active",
				contentClass = ".accordion__content",
				headerHeight = $(".header").height(),
				topOffsetValue;
			$(elemTarget).click(function (e) {
				e.stopPropagation();
				// //console.log("accordion");
				var $this = $(this);
				$this.parent(elem).toggleClass(activeClass);
				if ($this.parent(elem).hasClass(activeClass)) {
					$this.parent(elem).find(contentClass).stop().slideDown(200);
					$this.parent(elem).siblings().find(contentClass).stop().slideUp(500, function () {
						topOffsetValue = $this.offset().top;

						$("html").scrollTop(topOffsetValue - headerHeight)
					});
					$this.parent(elem).siblings().removeClass(activeClass);
				} else {
					$this.parent(elem).find(contentClass).stop().slideUp();
				}
			});
			// multi accordion
			$('.multi-toggle').click(function (e) {
				e.preventDefault();
				var $this = $(this);
				if ($this.next().hasClass('show')) {
					$this.removeClass('active');
					$this.next().removeClass('show');
					$this.next().slideUp(350);
				} else {
					$this.parent().parent().find('li .inner').removeClass('show');
					$this.parent().parent().find('li .inner').slideUp(350);
					$this.addClass('active');
					$this.next().toggleClass('show');
					$this.next().slideToggle(350);
				}
			});

		},

		roundSlier() {

			if (!$("#estimate-slider").length) return false;

			function _chartValues(obj) {
				const chartValues = ["100,000", "200,000", "300,000", "400,000", "500,000", "600,000", "700,000", "800,000", "900,000", "1000,000"]
				$('#chart-value').text(chartValues[obj.value]);
			}

			$("#estimate-slider").roundSlider({
				radius: 85,
				sliderType: "min-range",
				min: 0,
				max: 9,
				value: 2,
				radius: app.isMobile ? 140 : 165,
				width: app.isMobile ? 20 : 30,
				mouseScrollAction: true,
				editableTooltip: false,
				showTooltip: false,
				beforeCreate: function (obj) {
					// //console.log(obj);
					_chartValues(obj)
				},
				drag: function (obj) {
					// //console.log(obj.value);
					_chartValues(obj)
				},
				change: function (obj) {
					// //console.log(obj);
					_chartValues(obj)
				},
				stop: function (obj) {
					// //console.log(obj);
				},
				tooltipFormat: tooltipVal1
			});

			function tooltipVal1(args) {
				var months = ["January", "February", "March",
					"April", "May", "June", "July",
					"August", "September", "October",
					"November", "December"];

				return ` <h1> ${months[args.value]} </h1> `
			}









		},

		random() {
			$('.js-right-slide__btn').on('click', function () {
				$('.js-right-slide').toggleClass('js-right-slide--active');
				$(this).text(
					$(this).hasClass('js-right-slide__btn--active') ?
						$(this).data('slide-before')
						:
						$(this).data('slide-after')
				);
				$(this).toggleClass('js-right-slide__btn--active');
			});
			$('.js-back-btn-slide').on('click', function () {
				$('.js-right-slide').removeClass('js-right-slide--active');
				$('.js-right-slide__btn').removeClass('js-right-slide__btn--active');
				$('.js-right-slide__btn').text($('.js-right-slide__btn').data('slide-before'));
			});
		},

		iban: function () {



			var enableButton = false;

			$('#acc-number').keyup(function () {
				if (this.value.length > this.maxLength) {
					this.value = this.value.slice(0, this.maxLength);

					enableButton = true

				}

				else {

					enableButton = false
				}
			})

			$('.ban-generator__field').change(function (e) {
				e.preventDefault()

				$('.ban-generator__field').each(function () {

					if ($(this).val() !== '') {
						//	if (enableButton)
						$('.ban-generator .btn').removeClass('disabled')

					}
					else {
						//if (enableButton)
						$('.ban-generator .btn').addClass('disabled')
					}
				})
			})




			$('.ban-generator .btn').click(function () {




				$('.iban-bumber input').val(actionIbanForm($('#acc-number').val(), $('#dynamicmodel-branch_code').val()))

			})

		},

		gridSlideAnimation() {

			let parent = $('.feature-grid-lg__content');
			let gridCopy = $('.feature-grid-lg__copy');

			gridCopy.each(function(i, elem) {
				console.log($(elem).height());
				// console.log($(elem).outerHeight());
				$('.feature-grid-lg__slider-img').eq(i).height($(elem).height() + 40);
				if(i+1 === $('.feature-grid-lg__slider-img').length) {
					$('.feature-grid-lg__slider-img').eq(i).height($(elem).height() + 80);	
				}
				
			});


			parent.scroll(function (ev) {
				// console.log(parent.scrollTop());
				$('.feature-grid-lg__scroll').css({"transform": `translateY(-${parent.scrollTop()}px)`})
			});

			let counter = 0;
			let wrapper = $('.feature-slider-lg__wrapper');
			let wrapperHeight = wrapper.height();
			wrapper.on('click', function () {

				if ($('.feature-slider-lg__slider-img, .feature-slider-lg__copy').length / 2 > counter + 1) {
					counter++;
					$('.feature-slider-lg__scroll, .feature-slider-lg__content').css({ "transform": `translateY(-${wrapperHeight * counter}px)` });

					if ($('[data-svg-inverse]').data('svg-inverse') === counter) {
						console.log(true);
						wrapper.addClass('feature-slider-lg__wrapper--svg-inverse')
					}

				}

			});

		},
		language: function () {
			var link = window.location.href
			//console.log(app.culture)
			if (app.culture === 'en')
				$('.lang-btn').attr('href', link.replace('/en/', '/ar/'))
			else
				$('.lang-btn').attr('href', link.replace('/ar/', '/en/'))
		},

		init() {
			app.detectCulture();
			app.detectDevice();
			app.resizeListner();
			app.addEventListner();
			app.lazyLoad();
			app.swiper();
			app.productFinder();
			app.bankServices();
			app.tabs();
			app.rangeSlider();
			app.customSelect();
			app.lifestyleAnimation();
			app.accordion();
			app.roundSlier();
			app.random();
			app.googleMap();
			app.imageVideo();
			app.iban();
			app.gridSlideAnimation();
			app.language();

		},
	}
	window.app = app;

}(jQuery));

$(document).ready(() => {
	window.app.init();
});


function actionIbanForm(account_number, branch_code) {
	var iban = '';
	account_number = '4' + account_number.trim();
	if (account_number.length !== 7) {
		return false;
	}

	var output = '';

	var number_format = "14151120" + branch_code + "00000000000" + account_number + "192400";

	output += number_format + " - ";

	var first_mod = number_format.substr(0, 9) % 97;
	var first_mod_removed = number_format.substr(9);
	var checkdigit1 = first_mod + first_mod_removed;

	output += checkdigit1;

	first_mod = number_format.substr(0, 9) % 97;
	first_mod_removed = number_format.substr(9);
	checkdigit1 = first_mod + first_mod_removed;

	output += checkdigit1;

	first_mod = number_format.substr(0, 9) % 97;
	first_mod_removed = number_format.substr(9);
	checkdigit1 = first_mod + first_mod_removed;

	output += checkdigit1;

	first_mod = number_format.substr(0, 9) % 97;
	first_mod_removed = number_format.substr(9);
	checkdigit1 = first_mod + first_mod_removed;

	output += checkdigit1;

	checkdigit1 = checkdigit1 % 97;

	output += checkdigit1;

	var checkdigit_final = 98 - checkdigit1;

	output += checkdigit_final;

	var pad_left = '';
	if (checkdigit_final.length > 1) {
		pad_left = checkdigit_final.substr(0, 2);
	}
	else {
		pad_left = '0' + checkdigit_final;
	}



	iban = 'JO' + pad_left + 'EFBK' + branch_code + '00000000000' + account_number;



	return iban;
}

